<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-leave-type-color-cell">
    <template v-if="normalizedHex">
      <span
        class="orangehrm-leave-type-color-cell__swatch"
        :style="swatchStyle"
        :title="normalizedHex"
        role="img"
        :aria-label="normalizedHex"
      />
      <span class="orangehrm-leave-type-color-cell__code">{{
        normalizedHex
      }}</span>
    </template>
    <span v-else class="orangehrm-leave-type-color-cell--empty">—</span>
  </div>
</template>

<script>
export default {
  name: 'LeaveTypeColorSwatchCell',

  props: {
    hex: {
      type: String,
      default: null,
    },
  },

  computed: {
    normalizedHex() {
      if (this.hex == null || typeof this.hex !== 'string') {
        return null;
      }
      const trimmed = this.hex.trim();
      if (trimmed === '') {
        return null;
      }
      return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
    },
    swatchStyle() {
      if (!this.normalizedHex) {
        return {};
      }
      return {backgroundColor: this.normalizedHex};
    },
  },
};
</script>

<style lang="scss" scoped>
.orangehrm-leave-type-color-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 1.25rem;
}

.orangehrm-leave-type-color-cell__swatch {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  box-sizing: border-box;
}

.orangehrm-leave-type-color-cell__code {
  font-size: 0.875rem;
  word-break: break-all;
}

.orangehrm-leave-type-color-cell--empty {
  color: $oxd-interface-gray-color;
}
</style>
